import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from 'app/core/authentication/services/auth.service';
import { BrowserService } from 'app/core/browser/services/browser.service';
import { UserService } from 'app/core/user/services/user.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { AppRoute } from 'app/app-layout/constants';
import { RouterRequest } from 'app/core/browser/models';
import { UserInterface } from 'app/core/user/models';
import utilityCommon from 'app/core/utility/utility-common';

@Component({
  selector: 'cz-end-user-agreement',
  templateUrl: './end-user-agreement.component.html',
  styleUrls: ['./end-user-agreement.component.scss'],
})
export class EndUserAgreementComponent implements OnInit, OnDestroy {
  public agreementDeclined: boolean = false;
  public loggedInUser: UserInterface;
  public loggedInUserS: UserInterface;
  private readonly destroy$: Subject<boolean> = new Subject<boolean>();
  private updateEnd = false;

  constructor(private readonly _browserService: BrowserService,
              private readonly _authService: AuthService,
              private _translateService: TranslateService,
              private readonly _userService: UserService,
              private readonly _snackBar: MatSnackBar,
              private dialogRef: MatDialogRef<EndUserAgreementComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  public ngOnInit(): void {
    this._authService.getLoggedInUser().pipe(
      takeUntil(this.destroy$))
      .subscribe((user: UserInterface) => {
        if (!user) { return; }
        this.loggedInUser = user;
        this._userService.findOne(user.id).pipe(
          takeUntil(this.destroy$))
          .subscribe((updateUser: UserInterface) => {
            if (!updateUser) { return; }
            if (this.updateEnd) {
              this.updateEnd = false;
              this.dialogRef.close();   
              this.goToDashboard();
            }
          });
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public acceptAgreement(): void {
    this.loggedInUser = {
      ...this.loggedInUser,
      tcAccept: true,
    };

    this.updateEnd = true;
    this._userService.updateUserOnly(this.loggedInUser);
  }

  public declineAgreement(): void {
    this.agreementDeclined = true;
    const navRequest: RouterRequest = new RouterRequest({ route: AppRoute.login });
    this._browserService.to(navRequest);
    this._authService.signOut(false, 'api/logout?eulaAccepted=').subscribe((res: any) => {

    },                                                                     (error: any) => {

    });
    this.dialogRef.close();
  }

  public logout(): void {
    this.dialogRef.close();
    const navRequest: RouterRequest = new RouterRequest({ route: AppRoute.logout });
    this._browserService.to(navRequest);
  }
  public downloadPDF(): void {
    this.showSnackBar(this._translateService.instant('$pdf_download'));
    utilityCommon.pdfEULADownloadinSafari(this.loggedInUser.id);
  }
  public showSnackBar(message: string): void {
    this._snackBar.open(message, undefined, {
      duration: 5000,
    });
  }
  private goToDashboard(): void {
    const navRequest: RouterRequest = new RouterRequest({ route: AppRoute.myZone });
    this._browserService.to(navRequest);
  }
}
